import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerInfoStore: {
        backgroundColor: 'white',
    },
    containerNameStore: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 12,
        marginBottom: 4,
    },
    containerFilters: {
        flexDirection: 'row',
        paddingVertical: 6,
    },
    containerTags: {
        flexGrow: 0,
        flexDirection: 'row',
        backgroundColor: 'white',
        paddingVertical: 0,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    scrollViewBis: {
        flexGrow: 0,
    },
    containerPS: {
        flex: 1,
        minHeight: 300,
    },
    containerPriceItem: {
        flex: 1,
        flexDirection: 'row',
        marginHorizontal: 10,
        alignItems: 'center',
    },
    containerStoreData: {
        margin: 12,
        paddingVertical: 14,
        marginBottom: 20,
        borderRadius: 20,
    },
    storeImage: {
        width: 20,
        height: 20,
        marginRight: 8,
        borderRadius: 5,
        tintColor: 'white',
    },
    textNameStore: {
        fontSize: 19,
        fontWeight: 'bold',
        color: 'white',
    },
    textAddressStore: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
        marginBottom: 4,
    },
    textAddressStoreWithGoTo: {
        marginHorizontal: 12,
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        textDecorationLine: 'underline',
    },
    textInfoStore: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    storecode: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    progress: {
        borderRadius: 6,
        marginTop: 10,
        marginBottom: 8,
        marginHorizontal: 12,
        borderColor: theme.colors.colorPrimary,
    },
    containerSection: {
        flex: 1,
        marginHorizontal: 0,
        justifyContent: 'space-between',
    },
    stamp: {
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: theme.colors.colorPrimary,
        borderRadius: 10,
        paddingHorizontal: 8,
        paddingVertical: 2,
    },
    textStamp: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    textSection: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginLeft: 12,
    },
    textSectionDescription: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
        paddingTop: 5,
        marginBottom: 10,
    },
    containerItemsIndicators: {
        alignItems: 'center',
        paddingTop: 4,
        paddingBottom: 20,
    },
    containerItemsPS: {
        width: width / 4,
        alignItems: 'center',
        paddingBottom: 30,
        marginHorizontal: 0,
    },
    iconImage: {
        width: 32,
        height: 32,
        aspectRatio: 1,
        tintColor: theme.colors.colorPrimary,
    },
    textName: {
        fontSize: 12,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginTop: 8,
        marginHorizontal: 0,
    },
    containerItemsExecution: {
        width: width / 4,
        alignItems: 'center',
        marginHorizontal: 0,
        paddingBottom: 10,
    },
    containerProgress: {
        width: 90,
        height: 75,
        alignItems: 'center',
        justifyContent: 'center',
    },
    iconImageExecution: {
        width: 28,
        height: 28,
        aspectRatio: 1,
        position: 'absolute',
        tintColor: theme.colors.colorPrimary,
        backgroundColor: theme.colors.formsBackground,
        borderRadius: 0,
        marginBottom: 5,
    },
    textNameExecution: {
        fontSize: 11,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        paddingHorizontal: 0,
        marginTop: 5,
        marginBottom: 5,
    },
    textPercentage: {
        fontSize: 13,
        fontWeight: 'bold',
        position: 'absolute',
        zIndex: 2,
        top: 55,
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        padding: 0,
    },
    containerStatus: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    statusFormList: {
        justifyContent: 'center',
        alignContent: 'center',
        paddingHorizontal: 5,
        paddingVertical: 2,
        borderRadius: 5,
        alignSelf: 'flex-start',
    },
    textStatus: {
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
    },
    buttonContainer: {
        flexDirection: 'column',
        paddingVertical: 15,
        marginBottom: 12,
        width: '100%',
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    mainButton: {
        flexDirection: 'row',
        marginTop: 15,
        marginHorizontal: 15,
        //backgroundColor: theme.colors.colorPrimary,
        backgroundColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonActive: {
        flexDirection: 'row',
        marginTop: 15,
        marginHorizontal: 15,
        backgroundColor: theme.colors.colorPrimary,
        // backgroundColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: theme.colors.darkGray,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    mainButtonTextActive: {
        fontSize: 16,
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    checkInOutButton: {
        flexDirection: 'row',
        marginTop: 15,
        marginHorizontal: 15,
        backgroundColor: theme.colors.colorPrimary,
        borderWidth: 1.5,
        borderColor: 'white',
        padding: 10,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerFloatingButton: {
        paddingVertical: 16,
    },
    floatingButton: {
        flexDirection: 'row',
        backgroundColor: theme.colors.filtersBackground,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 15,
        marginBottom: 5,
        padding: 10,
    },
    floatingButtonText: {
        color: theme.colors.colorPrimary,
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'center',
        marginRight: 5,
    },
    horizontalLine: {
        borderBottomWidth: 2.0,
        borderBottomColor: theme.colors.colorPrimary,
        width: 130,
        alignSelf: 'center',
        marginHorizontal: 12,
        marginTop: 1,
        marginBottom: 12,
    },
    floatingButtonIcon: {
        width: 16,
        height: 16,
        tintColor: theme.colors.colorPrimary,
    },
    imageProduct: {
        width: 80,
        height: 80,
        justifyContent: 'center',
        alignSelf: 'center',
        borderRadius: 8,
    },
    containerInfoProduct: {
        flex: 3,
        flexDirection: 'column',
        marginHorizontal: 8,
    },
    product: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        lineHeight: 20,
    },
    productBis: {
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        fontSize: 15,
        fontWeight: '500',
        marginTop: 0,
    },
    ean: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: '600',
        textAlign: 'left',
        marginTop: 5,
    },
    sku: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: '600',
        textAlign: 'left',
        marginTop: 2,
    },
    price: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        marginRight: 12,
    },
    priceBis: {
        fontSize: 28,
        paddingTop: 12,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        marginRight: 12,
    },
    titleSection: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 10,
        paddingVertical: 5,
    },
    vouchersModule: {
        flex: 1,
        flexDirection: 'row',
        padding: 10,
        marginHorizontal: 10,
        marginVertical: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.colors.modalBackground,
    },
    voucherImage: {
        width: 65,
        marginVertical: 10,
        marginRight: 10,
        aspectRatio: 1,
        alignItems: 'center',
        borderRadius: 10,
    },
    voucherDescriptions: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    voucherTitle: {
        fontSize: 16,
        marginRight: 10,
        marginBottom: 5,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    voucherDescription: {
        fontSize: 15,
        marginRight: 10,
        marginBottom: 5,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    voucherPoints: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.colorSecondary,
    },
    voucherVigency: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.colorSecondary,
        alignSelf: 'center',
    },
    contentContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 0,
    },
    mediaContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.textPrimary,
        textAlign: 'center',
    },
    titleBis: {
        fontSize: 16,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.textPrimary,
        textAlign: 'center',
    },
    description: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        marginVertical: 10,
        paddingHorizontal: 25,
        textAlign: 'center',
        lineHeight: 20,
    },
    descriptionBis: {
        fontSize: 16,
        color: theme.colors.textSecondary,
        marginVertical: 10,
        paddingHorizontal: 25,
        textAlign: 'center',
        lineHeight: 20,
    },
    benefitAsset: {
        width: 200,
        height: 200,
        margin: 10,
        alignSelf: 'center',
    },
    titleQR: {
        fontSize: 22,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.colorPrimary,
        textAlign: 'center',
    },
    titleQRscaner: {
        fontSize: 18,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.colorApproved,
        textAlign: 'center',
    },
    containerNoMessage: {
        justifyContent: 'center',
        alignItems: 'center',
        height: '80%',
    },
    imageNoMessage: {
        width: 120,
        height: 120,
    },
    titleNoMessage: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    descriptionNoMessage: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    containerIndicator: {
        width: 120,
        borderRadius: 20,
        padding: 10,
        marginTop: 10,
        marginLeft: 8,
        justifyContent: 'center',
    },
    textIndicatorName: {
        fontSize: 11,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'white',
        paddingBottom: 10,
        paddingTop: 5,
    },
    textIndicatorData: {
        fontSize: 40,
        fontWeight: 'bold',
        color: 'white',
        marginBottom: 5,
    },
    textVariation: {
        fontSize: 12,
        fontWeight: 'normal',
        color: 'white',
        paddingTop: 10,
    },
    textViariationData: {
        fontSize: 13,
        fontWeight: 'bold',
        color: 'white',
    },
    messageContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        padding: 10,
        marginVertical: 10,
        borderRadius: 5,
    },
    imageAsset: {
        width: 120,
        height: 120,
    },
    titleText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    descriptionText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 25,
        paddingBottom: 12,
    },
    titleTextPG: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        paddingHorizontal: 12,
    },
    descriptionTextPG: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 12,
        paddingBottom: 12,
    },
    // Indicador de pagina en slide:
    floatPageIndicator: {
        top: 15,
        right: 10,
        paddingVertical: 5,
        paddingHorizontal: 10,
        backgroundColor: theme.colors.floatPageIndicatorBackground,
        borderRadius: 10,
        borderColor: 'black',
        borderWidth: 0.2,
        position: 'absolute',
        zIndex: 2,
    },
    floatPageIndicatorText: {
        color: 'black',
        fontSize: 12,
        fontWeight: 'bold',
    },
    bulletsContainer: {
        flexDirection: 'row',
        height: 0,
        width: width,
        alignSelf: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
    bulletsIndicator: {
        flexDirection: 'row',
        paddingVertical: 5,
        paddingHorizontal: 10,
        position: 'absolute',
        bottom: 0,
        alignSelf: 'center',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
    currentBulletIndicator: {
        width: 25,
        height: 6,
        borderRadius: 5,
        backgroundColor: theme.colors.colorPrimary,
        opacity: 1.0,
        marginHorizontal: 2,
    },
    circleBulletIndicator: {
        width: 6,
        height: 6,
        borderRadius: 5,
        backgroundColor: theme.colors.colorPrimary,
        opacity: 0.5,
        marginHorizontal: 2,
    },
    flexDirectionRow: { flexDirection: 'row', alignItems: 'center' },
    marginTop: { marginTop: 4 },
    marginTopTen: { marginTop: 10 },
    marginRight: { marginRight: 4 },
    marginHorizontal: { marginHorizontal: 12 },
    marginHorizontalSix: { marginHorizontal: 6 },
    alignCenter: { alignItems: 'center' },
    spacer1: { height: 4 },
    spacer: { height: 50 },
    spacerBis: { height: 24 },
})

export default styles
